import { konferenz, partner, themen } from '@/data/inhalte'

/** Nachrichtenband wie im Fernsehen - nur Angaben von der Karte. */
export default function Laufband() {
  const eintraege = [
    `${konferenz.datum} · ${konferenz.uhrzeit}`,
    konferenz.ort,
    ...themen.map(t => t.titel),
    `In Kooperation mit ${partner.map(p => p.name.split(' ')[0]).join(' · ')}`,
  ]
  const zeile = (
    <>
      {eintraege.map(e => (
        <span key={e} className="flex items-center gap-7 pr-7">
          <span className="whitespace-nowrap">{e}</span>
          <svg aria-hidden="true" viewBox="0 0 10 11.5" className="h-3 w-3 shrink-0 fill-konf-hell">
            <path d="M5 0l5 2.9v5.7L5 11.5 0 8.6V2.9z" />
          </svg>
        </span>
      ))}
    </>
  )
  return (
    <div className="laufband-huelle relative flex overflow-hidden border-y border-white/10 bg-konf-tief text-white">
      <p className="sr-only">{eintraege.join('. ')}</p>
      <span aria-hidden="true" className="relative z-10 flex shrink-0 items-center gap-2 bg-konf-hell px-4 py-3.5 font-display text-[13px] font-bold uppercase tracking-[0.22em] text-konf-nacht sm:px-5">
        <span className="h-2 w-2 rounded-full bg-[#E5322D] on-air" />
        Live {konferenz.datumKurz.slice(0, 6)}
      </span>
      <div aria-hidden="true" className="relative flex-1 overflow-hidden">
        <div className="laufband flex w-max items-center py-3.5 font-display text-[15px] font-bold uppercase tracking-[0.08em]">
          <div className="flex">{zeile}</div>
          <div className="flex">{zeile}</div>
        </div>
      </div>
    </div>
  )
}
